// routes.js
import { lazy } from "react";
import { PermissionMenuKey } from "utils/constants";
import Icon from "@mui/material/Icon";
import TourIcon from "@mui/icons-material/Tour";
import ChaletIcon from "@mui/icons-material/Chalet";
import RoomService from "@mui/icons-material/RoomService";
import CategoryIcon from "@mui/icons-material/Category";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ClassIcon from "@mui/icons-material/Class";
import DescriptionIcon from "@mui/icons-material/Description";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import MenuIcon from "@mui/icons-material/Menu";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import WidgetsIcon from "@mui/icons-material/Widgets";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import LayersIcon from "@mui/icons-material/Layers";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import WebhookIcon from "@mui/icons-material/Webhook";
import LandscapeIcon from "@mui/icons-material/Landscape";
import {
  Business,
  DataSaverOn,
  Language,
  Tour,
  Inventory2,
  WidthFull,
  Info,
  Feed,
  Layers,
  ControlCamera,
  DataUsage,
  Analytics,
  BarChart,
  Recommend,
  Note,
  NoteAlt,
} from "@mui/icons-material";
import ApprovalIcon from "@mui/icons-material/Approval";
import CameraFrontIcon from "@mui/icons-material/CameraFront";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import ExploreIcon from "@mui/icons-material/Explore";
import ReorderIcon from "@mui/icons-material/Reorder";
import { ShareRounded } from "@mui/icons-material";
import WallpaperIcon from "@mui/icons-material/Wallpaper";

// Lazy-loaded components
const MapComponent = lazy(() => import("./layouts/home/MapComponent"));
const Dashboard = lazy(() => import("./layouts/dashboard"));

const SignIn = lazy(() => import("./layouts/authentication/sign-in"));
const Cover = lazy(
  () => import("./layouts/authentication/reset-password/cover")
);
const ConfirmPassword = lazy(
  () => import("./layouts/authentication/confirm-password")
);
// dashboard
const LoaiDiaDiem = lazy(() => import("layouts/QuanLyDiaDiem/LoaiDiaDiem"));
const DiaDiem = lazy(() => import("layouts/QuanLyDiaDiem/DiaDiem"));
const KhuDiTich = lazy(() => import("./layouts/dulich/quanlykhuditich"));
const PhongTrungBay = lazy(() => import("./layouts/dulich/phongtrungbay"));
const MauVat = lazy(() => import("./layouts/dulich/mauvat"));
const DichVu = lazy(() => import("./layouts/dulich/dichvu"));
const SanPham = lazy(() => import("./layouts/dulich/sanpham"));
const QuanLyTour = lazy(() => import("./layouts/dulich/quanlyTour"));
const QuanLyStop = lazy(() => import("./layouts/dulich/quanlyTour/quanlyStop"));

const TinTucSuKien = lazy(() => import("./layouts/tinTucSuKien/tinTucSuKien"));
const QuanLyTinTuc = lazy(() => import("./layouts/tinTucSuKien/tinTuc"));
const QuanLyGioiThieu = lazy(() => import("./layouts/about/gioithieu"));
const GioiThieu = lazy(() => import("./layouts/gioiThieu/gioiThieu"));
const DetailAbout = lazy(() => import("./layouts/gioiThieu/detailAbout"));
const DetailNews = lazy(() => import("./layouts/tinTucSuKien/detailNews"));

const ThongtinModel3D = lazy(() => import("./layouts/danhmuc/thongtinmodel3d"));
const LopBanDoNen = lazy(() => import("./layouts/danhmuc/lopbandonen"));
const QuanLyVanBan = lazy(() => import("./layouts/vanban/quanLyVanBan"));
const NgonNgu = lazy(() => import("./layouts/danhmuc/ngonngu"));

const Users = lazy(() => import("./layouts/admin/users"));
const Roles = lazy(() => import("./layouts/admin/roles"));
const Menus = lazy(() => import("./layouts/admin/menu"));
const GroupMenus = lazy(() => import("./layouts/admin/groupmenu"));
const ActionLog = lazy(() => import("./layouts/admin/actionlog"));

const NhomSanPham = lazy(() => import("./layouts/danhmuc/nhomsanpham"));
const LoaiHinhDoanhNghiep = lazy(
  () => import("layouts/danhmuc/loaihinhdoanhnghiep")
);

const LoaiHinhDuLich = lazy(() => import("./layouts/danhmuc/loaihinhdulich"));
const LoaiDiTich = lazy(() => import("./layouts/dulich/loaiditich"));
const DonVi = lazy(() => import("layouts/danhmuc/donvihanhchinh"));
const PhongBan = lazy(() => import("layouts/danhmuc/phongban/phongban"));
const LoaiMauVat = lazy(() => import("layouts/danhmuc/loaimauvat/LoaiMauVat"));
const Setting = lazy(() => import("./layouts/setting/setting"));
const Share = lazy(() => import("./layouts/share"));

const LinhVucDauTu = lazy(() => import("./layouts/danhmuc/linhvucdautu"));
const NhomNganhNghe = lazy(() => import("./layouts/danhmuc/nhomnganhnghe"));
const NganhNghe = lazy(() => import("./layouts/danhmuc/nganhnghe"));
const LoaiDuAn = lazy(() => import("./layouts/danhmuc/loaiduan"));
const NhomDuAn = lazy(() => import("./layouts/danhmuc/nhomduan"));
const LoaiHinhKD = lazy(() => import("./layouts/danhmuc/loaihinhkd"));
const DoUuTien = lazy(() => import("./layouts/danhmuc/douutien"));
const TrangThai = lazy(() => import("./layouts/danhmuc/trangthai"));

const QuanLyDoanhNghiep = lazy(
  () => import("./layouts/quanlydautu/doanhNghiep/QuanLyDoanhNghiep")
);
const DuAn = lazy(() => import("./layouts/quanlydautu/duAn/QuanLyDuAn"));
const GiaHanDuAn = lazy(() => import("./layouts/quanlydautu/duAn/GiaHanDuAn"));
const TrangThaiDuAn = lazy(
  () => import("./layouts/quanlydautu/duAn/TrangThaiDuAn")
);
const ChuyenNhuongDuAn = lazy(
  () => import("./layouts/quanlydautu/ChuyenNhuongDuAn")
);
const KhuCumCongNghiep = lazy(
  () => import("./layouts/quanlydautu/khucumcongnghiep")
);
const ChiTietDatKhuCum = lazy(
  () => import("./layouts/quanlydautu/khucumcongnghiep/chiTietDatKhuCum")
);
const NhomDat = lazy(() => import("./layouts/QuanLyQuyHoach/NhomDat"));
const Dat = lazy(() => import("./layouts/QuanLyQuyHoach/Dat"));
const KyQuyHoach = lazy(() => import("./layouts/QuanLyQuyHoach/KyQuyHoach"));
const LoaiQuyHoach = lazy(
  () => import("./layouts/QuanLyQuyHoach/LoaiQuyHoach")
);
const QuyHoach = lazy(() => import("./layouts/QuanLyQuyHoach/QuanLyQuyHoach"));
const ChiTietQuyHoach = lazy(
  () => import("./layouts/QuanLyQuyHoach/ChiTietQuyHoach")
);
const FullZonePage = lazy(() => import("./layouts/home/FullZonePage"));
const NhomLopBanDo = lazy(
  () => import("./layouts/QuanLyQuyHoach/NhomLopBanDo")
);
const LopBanDo = lazy(() => import("./layouts/QuanLyQuyHoach/LopBanDo"));

const CoCauSuDungDatPage = lazy(
  () => import("./layouts/baocao/SuDungDat/CoCauSuDungDatPage")
);
const TinhHinhSuDungDatPage = lazy(
  () => import("./layouts/baocao/SuDungDat/TinhHinhSuDungDatPage")
);
const ThongKeSuDungDatPage = lazy(
  () => import("./layouts/baocao/SuDungDat/ThongKeSuDungDatPage")
);

const LoaiChuGiai = lazy(
  () => import("./layouts/danhmuc/loaichugiai/LoaiChuGiai")
);
const ChuGiai = lazy(() => import("./layouts/danhmuc/chugiai/ChuGiai"));

const allRoutes = [
  {
    access: 0,
    type: "collapse",
    name: "home",
    key: PermissionMenuKey.home,
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <MapComponent />, // App with default sidebar state (PLACE)
  },
  {
    access: 0,
    type: "collapse",
    name: "relics",
    hiding: true,
    key: PermissionMenuKey.Relics,
    icon: <TourIcon />,
    route: `/${PermissionMenuKey.Relics}`,
    component: <MapComponent activeSidebarItem="MUSEUM" />,
  },
  {
    access: 0,
    type: "collapse",
    name: "location",
    hiding: true,
    key: PermissionMenuKey.Place,
    icon: <ChaletIcon />,
    route: `/${PermissionMenuKey.Place}`,
    component: <MapComponent activeSidebarItem="PLACE" />, // Set sidebar to PLACE
  },
  {
    access: 0,
    type: "collapse",
    name: "location",
    hiding: true,
    key: PermissionMenuKey.Company,
    icon: <Business />,
    route: `/${PermissionMenuKey.Company}`,
    component: <MapComponent activeSidebarItem="COMPANY" />, // Set sidebar to COMPANY
  },
  {
    access: 0,
    type: "collapse",
    name: "location",
    hiding: true,
    key: PermissionMenuKey.Zone,
    icon: <Business />,
    route: `/${PermissionMenuKey.Zone}`,
    component: <MapComponent activeSidebarItem="ZONE" />, // Set sidebar to ZONE
  },
  {
    access: 0,
    type: "collapse",
    name: "location",
    hiding: true,
    key: PermissionMenuKey.Project,
    icon: <Business />,
    route: `/${PermissionMenuKey.Project}`,
    component: <MapComponent activeSidebarItem="PROJECT" />, // Set sidebar to PROJECT
  },
  {
    access: 0,
    type: "collapse",
    name: "location",
    hiding: true,
    key: PermissionMenuKey.ProjectInvestment,
    icon: <Recommend />,
    route: `/${PermissionMenuKey.ProjectInvestment}`,
    component: <MapComponent activeSidebarItem="PROGRESS" />,
  },
  {
    access: 0,
    type: "collapse",
    name: "fullzone",
    hiding: true,
    key: PermissionMenuKey.FullZone,
    icon: <WidthFull />,
    route: `/${PermissionMenuKey.FullZone}`,
    component: <FullZonePage />,
  },
  {
    access: 0,
    type: "collapse",
    name: "Xem Quy hoạch",
    hiding: true,
    key: PermissionMenuKey.viewQuyHoach,
    icon: <Business />,
    route: `/${PermissionMenuKey.viewQuyHoach}`,
    component: <MapComponent activeSidebarItem="VIEWQUYHOACH" />,
  },
  {
    access: 0,
    type: "collapse",
    name: "cocausudungdat",
    hiding: true,
    key: PermissionMenuKey.coCauSuDungDatPage,
    icon: <DataUsage />,
    route: `/${PermissionMenuKey.coCauSuDungDatPage}`,
    component: <CoCauSuDungDatPage />,
  },
  {
    access: 0,
    type: "collapse",
    name: "tinhhinhsudungdat",
    hiding: true,
    key: PermissionMenuKey.tinhHinhSuDungDatPage,
    icon: <Analytics />,
    route: `/${PermissionMenuKey.tinhHinhSuDungDatPage}`,
    component: <TinhHinhSuDungDatPage />,
  },
  {
    access: 0,
    type: "collapse",
    name: "thongkesudungdat",
    hiding: true,
    key: PermissionMenuKey.thongKeSuDungDatPage,
    icon: <BarChart />,
    route: `/${PermissionMenuKey.thongKeSuDungDatPage}`,
    component: <ThongKeSuDungDatPage />,
  },
  {
    access: 0,
    type: "collapse",
    name: "gallery",
    hiding: true,
    key: PermissionMenuKey.Gallery,
    icon: <RoomService />,
    route: `/${PermissionMenuKey.Gallery}`,
    component: <MapComponent activeSidebarItem="GALLERY" />, // Set sidebar to GALLERY
  },
  {
    access: 0,
    type: "collapse",
    name: "discover",
    hiding: true,
    key: PermissionMenuKey.Discover,
    icon: <TourIcon />,
    route: `/${PermissionMenuKey.Discover}`,
    component: <MapComponent activeSidebarItem="DISCOVER" />, // Set sidebar to DISCOVER
  },
  {
    access: 0,
    type: "collapse",
    name: "about",
    key: PermissionMenuKey.gioiThieu,
    hiding: true,
    icon: <Icon fontSize="small">info</Icon>,
    route: `/${PermissionMenuKey.gioiThieu}`,
    component: <GioiThieu />,
    collapse: [
      {
        access: 0,
        type: "collapse",
        name: "Giới thiệu",
        title: "Giới thiệu",
        key: PermissionMenuKey.gioiThieu,
        icon: <Icon fontSize="small">info</Icon>,
        route: `/${PermissionMenuKey.gioiThieu}/:slug`,
        component: <DetailAbout />,
      },
    ],
  },
  {
    access: 0,
    type: "collapse",
    name: "event_news",
    key: PermissionMenuKey.tinTuc,
    hiding: true,
    icon: <NewspaperIcon />,
    route: `/${PermissionMenuKey.tinTuc}`,
    component: <TinTucSuKien />,
    collapse: [
      {
        access: 0,
        type: "collapse",
        name: "Tin tức sự kiện",
        title: "Chi tiết tin tức",
        key: PermissionMenuKey.chiTietTinTuc,
        icon: <NewspaperIcon />,
        route: `/${PermissionMenuKey.tinTuc}/:slug`,
        component: <DetailNews />,
      },
    ],
  },
  {
    access: 3,
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
  },
  {
    access: 3,
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/reset-password",
    component: <Cover />,
  },
  {
    access: 3,
    type: "collapse",
    name: "Confirm Password",
    key: "confirm-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/confirmpassword/:uidb64/:token",
    component: <ConfirmPassword />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Thông tin Dashboard",
    key: PermissionMenuKey.dashboard,
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: `/${PermissionMenuKey.dashboard}`,
    component: <Dashboard />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý địa điểm",
    key: "quanlydiadiem",
    icon: <ChaletIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Địa điểm",
        title: "Địa điểm",
        key: PermissionMenuKey.diadiem,
        icon: <PersonPinIcon />,
        route: `/quanlydiadiem/diadiem`,
        component: <DiaDiem />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Loại Địa điểm",
        title: "Loại Địa điểm",
        key: PermissionMenuKey.loaidiadiem,
        icon: <GpsFixedIcon />,
        route: `/quanlydiadiem/loaidiadiem`,
        component: <LoaiDiaDiem />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý du lịch",
    key: "dulich",
    icon: <TourIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Quản lý khu di tích",
        title: "Quản lý khu di tích",
        key: PermissionMenuKey.quanlyKhuditich,
        icon: <Tour />,
        route: `/dulich/${PermissionMenuKey.quanlyKhuditich}`,
        component: <KhuDiTich />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản lý Phòng trưng bày",
        title: "Quản lý Phòng trưng bày",
        key: PermissionMenuKey.phongTrungbay,
        icon: <RoomService />,
        route: `/dulich/${PermissionMenuKey.phongTrungbay}`,
        component: <PhongTrungBay />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản lý Mẫu vật",
        title: "Quản lý Mẫu vật",
        key: PermissionMenuKey.mauVat,
        icon: <CategoryIcon />,
        route: `/dulich/${PermissionMenuKey.mauVat}`,
        component: <MauVat />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản lý Dịch vụ",
        title: "Quản lý Dịch vụ",
        key: PermissionMenuKey.dichVu,
        icon: <AddPhotoAlternateIcon />,
        route: `/dulich/${PermissionMenuKey.dichVu}`,
        component: <DichVu />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Sản phẩm dịch vụ",
        title: "Sản phẩm dịch vụ",
        key: PermissionMenuKey.sanPham,
        icon: <CategoryIcon />,
        route: `/dulich/${PermissionMenuKey.sanPham}`,
        component: <SanPham />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Tour du lịch",
    key: "discovers",
    icon: <ExploreIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Tour",
        title: "Tour",
        key: PermissionMenuKey.Tour,
        icon: <TravelExploreIcon />,
        route: `/discovers/${PermissionMenuKey.Tour}`,
        component: <QuanLyTour />,
        collapse: [
          {
            access: 1,
            type: "collapse",
            hiding: true,
            name: "Điểm dừng chân tham quan",
            title: "Điểm dừng chân tham quan",
            key: PermissionMenuKey.Stop,
            route: `/discovers/${PermissionMenuKey.Tour}/${PermissionMenuKey.Stop}/:id`,
            component: <QuanLyStop />,
          },
        ],
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Xúc tiến đầu tư",
    key: "quanlydautu",
    icon: <Business />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Quản lý doanh nghiệp",
        title: "Quản lý doanh nghiệp",
        key: PermissionMenuKey.doanhNghiep,
        icon: <CameraFrontIcon />,
        route: `/quanlydautu/${PermissionMenuKey.doanhNghiep}`,
        component: <QuanLyDoanhNghiep />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Dự án",
        title: "Dự án",
        key: PermissionMenuKey.duAn,
        icon: <ApprovalIcon />,
        route: `/quanlydautu/${PermissionMenuKey.duAn}`,
        component: <DuAn />,
        collapse: [
          {
            access: 1,
            type: "children",
            hiding: true,
            name: "Chuyển nhượng dự án",
            title: "Chuyển nhượng dự án",
            key: PermissionMenuKey.chuyenNhuongDuAn,
            route: `/quanlydautu/duan/${PermissionMenuKey.chuyenNhuongDuAn}/:id`,
            component: <ChuyenNhuongDuAn />,
          },
          {
            access: 1,
            type: "children",
            hiding: true,
            name: "Lịch sử dự án",
            title: "Lịch sử dự án",
            key: PermissionMenuKey.lichSuDuAn,
            route: `/quanlydautu/duan/${PermissionMenuKey.lichSuDuAn}/:id`,
            component: <TrangThaiDuAn />,
          },
        ],
      },
      {
        access: 1,
        type: "collapse",
        name: "Dự án gia hạn",
        title: "Dự án gia hạn",
        key: PermissionMenuKey.duAnGiahan,
        icon: <CameraswitchIcon />,
        route: `/quanlydautu/${PermissionMenuKey.duAnGiahan}`,
        component: <GiaHanDuAn />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Khu cụm công nghiệp",
        title: "Khu cụm công nghiệp",
        key: PermissionMenuKey.khuCumCongNghiep,
        icon: <SatelliteAltIcon />,
        route: `/quanlydautu/${PermissionMenuKey.khuCumCongNghiep}`,
        component: <KhuCumCongNghiep />,
        collapse: [
          {
            access: 1,
            type: "children",
            hiding: true,
            name: "Chi tiết đất khu cụm công nghiệp",
            title: "Chi tiết đất khu cụm công nghiệp",
            key: PermissionMenuKey.chitietKhucum,
            route: `/quanlydautu/${PermissionMenuKey.khuCumCongNghiep}/${PermissionMenuKey.chitietKhucum}/:id`,
            component: <ChiTietDatKhuCum />,
          },
        ],
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Quy hoạch",
    key: "quyhoach",
    icon: <ControlCamera />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Nhóm đất",
        title: "Nhóm đất",
        key: PermissionMenuKey.nhomDat,
        icon: <BookmarkAddedIcon />,
        route: `/quyhoach/${PermissionMenuKey.nhomDat}`,
        component: <NhomDat />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Đất",
        title: "Đất",
        key: PermissionMenuKey.dat,
        icon: <BrokenImageIcon />,
        route: `/quyhoach/${PermissionMenuKey.dat}`,
        component: <Dat />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Kỳ quy hoạch",
        title: "Kỳ quy hoạch",
        key: PermissionMenuKey.kyQuyHoach,
        icon: <WebhookIcon />,
        route: `/quyhoach/${PermissionMenuKey.kyQuyHoach}`,
        component: <KyQuyHoach />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Loại quy hoạch",
        title: "Loại quy hoạch",
        key: PermissionMenuKey.loaiQuyHoach,
        icon: <LandscapeIcon />,
        route: `/quyhoach/${PermissionMenuKey.loaiQuyHoach}`,
        component: <LoaiQuyHoach />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quy hoạch",
        title: "Quy hoạch",
        key: PermissionMenuKey.quyHoach,
        icon: <WallpaperIcon />,
        route: `/quyhoach/${PermissionMenuKey.quyHoach}`,
        component: <QuyHoach />,
        collapse: [
          {
            access: 1,
            type: "children",
            hiding: true,
            name: "Chi tiết quy hoạch đất",
            title: "Chi tiết quy hoạch đất",
            key: PermissionMenuKey.chitietQuyhoach,
            route: `/quyhoach/${PermissionMenuKey.quyHoach}/${PermissionMenuKey.chitietQuyhoach}/:id`,
            component: <ChiTietQuyHoach />,
          },
        ],
      },
      {
        access: 1,
        type: "collapse",
        name: "Nhóm lớp bản đồ Quy hoạch",
        title: "Nhóm lớp bản đồ Quy hoạch",
        key: PermissionMenuKey.nhomLopbandoQuyHoach,
        icon: <Layers />,
        route: `/quyhoach/${PermissionMenuKey.nhomLopbandoQuyHoach}`,
        component: <NhomLopBanDo />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Lớp bản đồ Quy hoạch",
        title: "Lớp bản đồ Quy hoạch",
        key: PermissionMenuKey.lopbandoQuyHoach,
        icon: <Layers />,
        route: `/quyhoach/${PermissionMenuKey.lopbandoQuyHoach}`,
        component: <LopBanDo />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Website",
    key: "quanlysite",
    icon: <WebAssetIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Tin tức",
        key: PermissionMenuKey.quanLyTinTuc,
        icon: <NewspaperIcon />,
        route: `/website/${PermissionMenuKey.quanLyTinTuc}`,
        component: <QuanLyTinTuc />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Giới thiệu Website",
        key: PermissionMenuKey.quanLyGioiThieu,
        icon: <NewspaperIcon />,
        route: `website/${PermissionMenuKey.quanLyGioiThieu}`,
        component: <QuanLyGioiThieu />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Danh mục",
    key: "danhmuc",
    icon: <ClassIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Đơn vị hành chính",
        title: "Đơn vị hành chính",
        key: PermissionMenuKey.donViHanhChinh,
        icon: <PermDataSettingIcon />,
        route: `/danhmuc/${PermissionMenuKey.donViHanhChinh}`,
        component: <DonVi />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Phòng ban",
        title: "Phòng ban",
        key: PermissionMenuKey.phongBan,
        icon: <PermDataSettingIcon />,
        route: `/danhmuc/${PermissionMenuKey.phongBan}`,
        component: <PhongBan />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Danh mục du lịch",
        key: "danhmucdulich",
        icon: <LabelImportantIcon />,
        route: null,
        component: null,
        collapse: [
          {
            access: 1,
            type: "collapse",
            name: "Loại hình du lịch",
            title: "Loại hình du lịch",
            key: PermissionMenuKey.loaihinhDulich,
            icon: <ReorderIcon />,
            route: `/danhmuc/danhmucdulich/${PermissionMenuKey.loaihinhDulich}`,
            component: <LoaiHinhDuLich />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Loại di tích",
            title: "Loại di tích",
            key: PermissionMenuKey.loaiDitich,
            icon: <ReorderIcon />,
            route: `/danhmuc/danhmucdulich/${PermissionMenuKey.loaiDitich}`,
            component: <LoaiDiTich />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Loại mẫu vật",
            title: "Loại mẫu vật",
            key: PermissionMenuKey.loaiMauVat,
            icon: <ReorderIcon />,
            route: `/danhmuc/danhmucdulich/${PermissionMenuKey.loaiMauVat}`,
            component: <LoaiMauVat />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Nhóm sản phẩm",
            title: "Nhóm sản phẩm",
            key: PermissionMenuKey.nhomsanPham,
            icon: <CategoryIcon />,
            route: `/danhmuc/danhmucdulich/${PermissionMenuKey.nhomsanPham}`,
            component: <NhomSanPham />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Thông tin lớp 3D",
            title: "Thông tin lớp 3D",
            key: PermissionMenuKey.lopbando3D,
            icon: <WysiwygIcon />,
            route: `/danhmuc/danhmucdulich/${PermissionMenuKey.lopbando3D}`,
            component: <ThongtinModel3D />,
          },
        ],
      },
      {
        access: 1,
        type: "collapse",
        name: "Danh mục đầu tư",
        key: "danhmucdautu",
        icon: <LabelImportantIcon />,
        route: null,
        component: null,
        collapse: [
          {
            access: 1,
            type: "collapse",
            name: "Loại hình doanh nghiệp",
            title: "Loại hình doanh nghiệp",
            key: PermissionMenuKey.loaiHinhDoanhNghiep,
            icon: <Business />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.loaiHinhDoanhNghiep}`,
            component: <LoaiHinhDoanhNghiep />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Nhóm ngành nghề KD",
            title: "Nhóm ngành nghề KD",
            key: PermissionMenuKey.nhomNganh,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.nhomNganh}`,
            component: <NhomNganhNghe />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Ngành nghề kinh doanh",
            title: "Ngành nghề kinh doanh",
            key: PermissionMenuKey.nganhNghe,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.nganhNghe}`,
            component: <NganhNghe />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Lĩnh vực đầu tư",
            title: "Lĩnh vực đầu tư",
            key: PermissionMenuKey.linhVucDautu,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.linhVucDautu}`,
            component: <LinhVucDauTu />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Loại dự án",
            title: "Loại dự án",
            key: PermissionMenuKey.loaiDuAn,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.loaiDuAn}`,
            component: <LoaiDuAn />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Nhóm dự án",
            title: "Nhóm dự án",
            key: PermissionMenuKey.nhomDuAn,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.nhomDuAn}`,
            component: <NhomDuAn />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Loại hình kinh doanh",
            title: "Loại hình kinh doanh",
            key: PermissionMenuKey.loaiHinhKD,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.loaiHinhKD}`,
            component: <LoaiHinhKD />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Độ ưu tiên dự án",
            title: "Độ ưu tiên dự án",
            key: PermissionMenuKey.doUutien,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.doUutien}`,
            component: <DoUuTien />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Trạng thái",
            title: "Trạng thái",
            key: PermissionMenuKey.trangThai,
            icon: <Inventory2 />,
            route: `/danhmuc/danhmucdautu/${PermissionMenuKey.trangThai}`,
            component: <TrangThai />,
          },
        ],
      },
      {
        access: 1,
        type: "collapse",
        name: "Ngôn ngữ",
        title: "Ngôn ngữ",
        key: PermissionMenuKey.ngonNgu,
        icon: <Language />,
        route: `/danhmuc/${PermissionMenuKey.ngonNgu}`,
        component: <NgonNgu />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Lớp bản đồ nền",
        title: "Lớp bản đồ nền",
        key: PermissionMenuKey.lopbandoNen,
        icon: <LayersIcon />,
        route: `/danhmuc/${PermissionMenuKey.lopbandoNen}`,
        component: <LopBanDoNen />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Loại chú giải",
        title: "Loại chú giải",
        key: PermissionMenuKey.loaiChugiai,
        icon: <Note />,
        route: `/danhmuc/${PermissionMenuKey.loaiChugiai}`,
        component: <LoaiChuGiai />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Chú giải",
        title: "Chú giải",
        key: PermissionMenuKey.Chugiai,
        icon: <NoteAlt />,
        route: `/danhmuc/${PermissionMenuKey.Chugiai}`,
        component: <ChuGiai />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý văn bản ngành",
    key: PermissionMenuKey.quanlyvanban,
    icon: <DescriptionIcon />,
    route: `/${PermissionMenuKey.quanlyvanban}`,
    component: <QuanLyVanBan />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Thiết lập hệ thống",
    key: PermissionMenuKey.setting,
    icon: <Icon fontSize="small">settings</Icon>,
    hiding: true,
    route: `/${PermissionMenuKey.setting}`,
    component: <Setting />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Tích hợp và chia sẻ dữ liệu",
    key: PermissionMenuKey.share,
    icon: <ShareRounded />,
    route: `/${PermissionMenuKey.share}`,
    component: <Share />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản trị hệ thống",
    key: "admin",
    icon: <ManageAccountsIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "children",
        name: "Danh sách người dùng",
        key: PermissionMenuKey.users,
        icon: <Icon fontSize="small">people</Icon>,
        route: `/admin/${PermissionMenuKey.users}`,
        component: <Users />,
      },
      {
        access: 1,
        type: "children",
        name: "Danh sách quyền",
        key: PermissionMenuKey.roles,
        icon: <AdminPanelSettingsIcon />,
        route: `/admin/${PermissionMenuKey.roles}`,
        component: <Roles />,
      },
      {
        access: 1,
        type: "children",
        name: "Danh sách chức năng",
        key: PermissionMenuKey.menu,
        icon: <WidgetsIcon />,
        route: `/admin/${PermissionMenuKey.menu}`,
        component: <Menus />,
      },
      {
        access: 1,
        type: "children",
        name: "Danh sách nhóm chức năng",
        key: PermissionMenuKey.groupMenu,
        icon: <MenuIcon />,
        route: `/admin/${PermissionMenuKey.groupMenu}`,
        component: <GroupMenus />,
      },
      {
        access: 1,
        type: "children",
        name: "Lịch sử nhật ký hệ thống",
        key: PermissionMenuKey.actionLog,
        icon: <DataSaverOn />,
        route: `/admin/${PermissionMenuKey.actionLog}`,
        component: <ActionLog />,
      },
    ],
  },
];

export default allRoutes;
